import type { ModelEditButtonProps } from "./model-edit-button.type";

import { useAuthorization } from "@/modules/authorization";
import { EditButton } from "@/ui/edit-button";

const ModelEditButton = ({ item, ...buttonProps }: ModelEditButtonProps) => {
  const { canUpdate } = useAuthorization();

  if (!canUpdate(item)) return null;

  return <EditButton {...buttonProps} />;
};

export default ModelEditButton;
